import request from '@/utils/request3'
import store from '@/store'
const serviceName = store.state.serviceName.workOrder

//获取当前登陆人待处理的消息
export function pageCurrentUser(data) {
    return request({
        url: serviceName + `/msg-receive/page-current-user`,
        method: 'post',
        data: data
    })
}
//通过id修改消息接收
export function updateById(data) {
    return request({
        url: serviceName + `/msg-receive/updateById`,
        method: 'post',
        data: data
    })
}
//批量处理消息
export function receiveBatch(data) {
    return request({
        url: serviceName + `/msg-receive/receive-batch`,
        method: 'post',
        data: data
    })
}